const getUniqueElements = elements => Array.from(new Set(elements));

export default getUniqueElements;
